<script lang="ts" setup>
import type { Temporal } from 'temporal-polyfill';

import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { computed } from 'vue';
import { plainDateRangeAdapter } from '#layers/ui/utils/range-value-adapter';
import DateTimePickerRangeBase from './RangeBase.vue';
import DateTimePickerTriggerButton from './TriggerButton.vue';

interface Props extends Pick<ButtonProps, 'size' | 'disabled'> {
	readonly?: boolean;
	block?: boolean;
	disableFutureDates?: boolean;
}

const { block = true, disableFutureDates = false, size, disabled, readonly } = defineProps<Props>();

const startDate = defineModel<Temporal.PlainDate | null>('startDate');
const endDate = defineModel<Temporal.PlainDate | null>('endDate');

const pickerProps = computed(() => ({ size, disabled, readonly, block, disableFutureDates }));
const triggerProps = computed(() => ({ size, disabled }));
</script>

<template>
	<DateTimePickerRangeBase
		v-bind="pickerProps"
		v-model:start-date="startDate"
		v-model:end-date="endDate"
		:adapter="plainDateRangeAdapter"
	>
		<template #trigger="{ rangeFieldDisplay, isRangeEmpty, canClearRange, clearRange }">
			<DateTimePickerTriggerButton
				v-bind="triggerProps"
				:label="rangeFieldDisplay"
				:is-empty="isRangeEmpty"
				:can-clear="canClearRange"
				:readonly
				:block
				data-testid="date-range-trigger"
				clear-data-testid="date-range-clear-range"
				@clear="clearRange"
			/>
		</template>
	</DateTimePickerRangeBase>
</template>
